import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LanguageModel } from '../../models'

export interface LanguagedState {
    Language: LanguageModel
    LanguageList: LanguageModel[]
}

const initialState: LanguagedState = {
    Language: {} as LanguageModel,
    LanguageList: [],
}

export const LanguageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguages: (state, action: PayloadAction<LanguageModel[]>) => {
            state.LanguageList = action.payload
        },
        saveLanguage: (state, action: PayloadAction<LanguageModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: LanguageModel = {
                    Id: model.Id,
                    LanguageName: model.LanguageName,
                    WhatToDo: model.WhatToDo,
                    WhatToDont: model.LanguageName,
                }
                let currentModel = state.LanguageList.find((c) => c.Id === model.Id) || defaultModel
                currentModel.LanguageName = model.LanguageName
                currentModel.WhatToDo = model.WhatToDo
                currentModel.WhatToDont = model.WhatToDont
            } else {
                model.Id = (Math.max(...state.LanguageList.map((c) => c.Id)) || 0) + 1
                state.LanguageList.push(model)
            }
        },
        getLanguageById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: LanguageModel = {} as LanguageModel
            if (id > 0) {
                let currentList: LanguageModel[] = state.LanguageList
                model = currentList.find((c) => c.Id === id) || ({} as LanguageModel)
            }

            state.Language = model
        },
        deleteLanguages: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: LanguageModel[] = state.LanguageList
                state.LanguageList = currentList.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setLanguages, saveLanguage, getLanguageById, deleteLanguages } =
    LanguageSlice.actions

export default LanguageSlice.reducer
